import axios from 'axios'
import _ from 'lodash'

export default class {
  _uploadUrl
  constructor() {
    this._uploadUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_UPLOAD_OPERATION}`
  }

  uploadToS3(files) {
    let formData = new FormData()

    _.forEach(files, f => {
      formData.append('documento', f)
    })

    return axios.post(this._uploadUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        maxContentLength: 100000000,
        maxBodyLength: 1000000000
      }
    })
  }
}
